import React from "react";
import { Box, useTheme } from "@chakra-ui/react";
import DashboardMenuItems from "../components/DashboardMenuItems";
const DashboardScreen = () => {
  const theme = useTheme();
  return (
    <Box
      w={"20%"}
      boxShadow={"sm"}
      border={theme.borders.custom}
      bg={"white"}
      height={"full"}
      borderRadius={"10px"}
        >
      <DashboardMenuItems />
    </Box>
  );
};

export default DashboardScreen;
